import States from '../../helpers/states';
import HomepageIndex from './homepage-index';

export default class HomepageEdgeDesktop extends HomepageIndex {

    _currentScreen = 0;
    _saveScreen = 0;
    _totalHeightSections = 0;
    _stepScreen = [];
    _heightPassed = 0;
    _currentTranslateY = 0;
    _currentScroll = 0;
    _sectionsData = [];
    _allowScrollScreen = true;

    constructor(...args) {
        super(...args);

        bindAll(this, [
            '_scrollHandler',
        ]);

        this._retrieveDOM();
    }

    _retrieveDOM() {
        super._retrieveDOM();

        /** Sections **/
        this.dom.views.sections = {
            container: this.dom.page.querySelector('.js-section-container'),
            containerFixed: null,
            sections: []
        }
        this.dom.views.sections.containerFixed = this.dom.views.sections.container.querySelector('.js-section-container-fixed');
        this.dom.views.sections.sections = this.dom.views.sections.containerFixed.querySelectorAll('.js-home-section');
        this._sectionLength = this.dom.views.sections.sections.length;

        this.dom.views.shadow = this.dom.views.sections.containerFixed.querySelectorAll('.js-shadow');

        for( let i = 0, j = this.dom.views.sections.sections.length; i < j; i++ ) {

            let section = this.dom.views.sections.sections[i];

            section.style.zIndex = this._sectionLength - i;

            let sectionData = {
                isScrollInside : ( section.querySelector('.js-content-scroll-wrapper') ) ? true : false
            };
            if( sectionData.isScrollInside ) {
                sectionData.contentScroll = section.querySelector('.js-content-scroll-wrapper');
                sectionData.isScrollMax = false;
            }

            this._sectionsData.push( sectionData );
        }

        this._updateSizeScreen();
    }

    init() {
        super.init();
    }


    bind() {
        super.bind();

        window.addEventListener('scroll', this._scrollHandler, {passive: false});
        window.addEventListener('wheel', this._scrollHandler, {passive: false});
        window.addEventListener('mousewheel', this._scrollHandler, {passive: false});
        document.addEventListener('mousewheel',  this._scrollHandler, {passive: false} );
    }

    /**
     * Called when the user scroll
     */
    _scrollHandler( event ) {

        this._currentTranslateY = window.scrollY || window.pageYOffset;
        this._animateScreen();
    }

    _animateScreen() {

        // this._currentScroll = this._currentTranslateY - ( this._currentScreen * States.height ); // 1
        // this._currentScreen = Math.max( 0, Math.floor( this._currentTranslateY  / States.height )); // 2

        // 2
        this._heightPassed = 0;
        for( let i = 0; i < this._stepScreen.length; i++ ) {
            if( this._currentTranslateY >= this._stepScreen[i] ) {
                this._heightPassed = this._stepScreen[i];
            }
            if( this._currentTranslateY < this._stepScreen[i] ) {
                this._currentScreen = i;
                break;
            }
        }

        this._currentScroll = this._currentTranslateY - ( this._heightPassed );

        if(
            ( this._sectionsData[ this._currentScreen ].isScrollInside )
            && ( this._currentScroll < this._sectionsData[ this._currentScreen ].contentHeight )
        ) {

            this._fixePositioOdlScreen();

            if( this._allowScrollScreen ) {
                this._sectionsData[ this._currentScreen ].isScrollMax = false;
                TweenMax.to( this._sectionsData[this._currentScreen].contentScroll, 0, { y: this._currentScroll * -1 , ease:Power1.easeOut } );
            }

        } else {

            if( this.dom.views.sections.sections[ this._currentScreen ].classList.contains('prev-page') )
                this.dom.views.sections.sections[ this._currentScreen ].classList.remove('prev-page');

            this._fixePositionChild();
            this._fixePositioOdlScreen();

            if( this._sectionsData[ this._currentScreen ].isScrollInside ) {
                this._currentScroll -= this._sectionsData[ this._currentScreen ].contentHeight;
            }

            if( this._allowScrollScreen && (this._currentScreen < this._sectionLength - 1) )
                TweenMax.to( this.dom.views.sections.sections[ this._currentScreen ], 0, { y: this._currentScroll * -1 , ease:Power1.easeOut } );
            TweenMax.to( this.dom.views.shadow, 0, { opacity: 1 - (this._currentScroll / States.height), zIndex: this.dom.views.sections.sections[ this._currentScreen ].style.zIndex, ease:Power1.easeOut } );
        }
    }

    _fixePositionChild() {

        if( this._currentScreen != this._saveScreen ) {

            if(
                ( this._sectionsData[ this._saveScreen ].isScrollInside )
            ) {

                let posY = ( this._currentScreen < this._saveScreen ) ? 0 : -1;
                TweenMax.to( this._sectionsData[this._saveScreen].contentScroll, 0,
                    {
                        y: this._sectionsData[ this._saveScreen ].contentHeight * posY ,
                        ease:Power1.easeOut,
                        onComplete: () => {
                            this._sectionsData[ this._saveScreen ].isScrollMax = true;
                        }
                    }
                );
            }

        } else {

            if(
                ( this._sectionsData[ this._currentScreen ].isScrollInside )
                && ( this._sectionsData[ this._currentScreen ].isScrollMax == false )
            ) {
                TweenMax.to( this._sectionsData[this._currentScreen].contentScroll, 0,
                    {
                        y: this._sectionsData[ this._currentScreen ].contentHeight * -1 ,
                        ease:Power1.easeOut,
                        onComplete: () => {
                            this._sectionsData[ this._currentScreen ].isScrollMax = true;
                        }
                    }
                );
            }
        }
    }

    _fixePositioOdlScreen() {

        if( this._currentScreen != this._saveScreen ) {
            this._allowScrollScreen = false;

            let posY = ( this._saveScreen < this._currentScreen ) ? -1 : 0;

            TweenMax.to( this.dom.views.sections.sections[ this._saveScreen ], 0,
                {
                    y: States.height * posY ,
                    ease:Power1.easeOut,
                    onComplete: () => {
                        if( this._saveScreen < this._currentScreen )
                            this.dom.views.sections.sections[ this._saveScreen ].classList.add('prev-page');

                        this._saveScreen = this._currentScreen;
                        this._allowScrollScreen = true;
                    }
                }
            );
        }
    }

    resize(width, height) {
        super.resize(width, height);

        this._updateSizeScreen();
    }

    _updateSizeScreen() {

        this._stepScreen = [];
        this._totalHeightSections = 0;

        for( let i = 0, j = this.dom.views.sections.sections.length; i < j; i++ ) {

            if( this._sectionsData[i].isScrollInside ) {
                this._sectionsData[i].contentHeight = this._sectionsData[i].contentScroll.offsetHeight - States.height;

                // Set pos child in screen
                let posY = ( i < this._currentScreen ) ? -1 : 0;
                TweenMax.set( this._sectionsData[ i ].contentScroll,
                    {
                        y: this._sectionsData[ i ].contentHeight * posY
                    }
                );
            }

            this._totalHeightSections += (this._sectionsData[i].isScrollInside) ? this._sectionsData[i].contentScroll.offsetHeight : this.dom.views.sections.sections[i].offsetHeight ;

            this._stepScreen.push( this._totalHeightSections );

            // Set pos screen
            let posYScreen = ( i < this._currentScreen ) ? -1 : 0;
            TweenMax.set( this.dom.views.sections.sections[ i ],
                {
                    y: States.height * posYScreen
                }
            );
        }

        // this._totalHeightSections -= States.height;
        this.dom.views.sections.container.style.height = this._totalHeightSections + 'px';

        this._animateScreen();
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// src/js/pages/homepage/homepage-edge.desktop.js